import type { FormatEurAmount } from "./types";

// Prices are stored in EUR; a non-EUR project would carry its currency on the project itself
export const formatEurAmount: FormatEurAmount = ({ amount, language }) =>
  new Intl.NumberFormat(language, {
    style: "currency",
    currency: "EUR",
  }).format(amount);
